/** 로컬 기준 오늘 YYYY-MM-DD */
export function todayStr(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export function formatDate(year: number, month: number, day: number): string {
  return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}

export function calcYearMonth(
  year: number,
  month: number,
  dir: 'prev' | 'next',
): { year: number; month: number } {
  if (dir === 'prev')
    return month === 1 ? { year: year - 1, month: 12 } : { year, month: month - 1 };
  return month === 12 ? { year: year + 1, month: 1 } : { year, month: month + 1 };
}

export interface DayCell {
  date: string;
  day: number;
  inCurrentMonth: boolean;
}

/** year/month(1-12)에 대한 6주 그리드 셀 목록 (앞뒤 달 채움 포함) */
export function monthCells(year: number, month: number): DayCell[] {
  const firstDayIndex = new Date(year, month - 1, 1).getDay();
  const daysInCurrent = new Date(year, month, 0).getDate();
  const prev = calcYearMonth(year, month, 'prev');
  const daysInPrev = new Date(prev.year, prev.month, 0).getDate();
  const next = calcYearMonth(year, month, 'next');

  const cells: DayCell[] = [];
  for (let i = firstDayIndex - 1; i >= 0; i--) {
    const day = daysInPrev - i;
    cells.push({ date: formatDate(prev.year, prev.month, day), day, inCurrentMonth: false });
  }
  for (let day = 1; day <= daysInCurrent; day++) {
    cells.push({ date: formatDate(year, month, day), day, inCurrentMonth: true });
  }
  const remaining = (7 - (cells.length % 7)) % 7;
  for (let day = 1; day <= remaining; day++) {
    cells.push({ date: formatDate(next.year, next.month, day), day, inCurrentMonth: false });
  }
  return cells;
}

export const WEEK_LABELS = ['일', '월', '화', '수', '목', '금', '토'] as const;
